import React from 'react'

import { graphql, StaticQuery } from 'gatsby'

import * as S from './styled'

const Testimonies = ({ ...rest }) => (
  <StaticQuery
    query={graphql`
      query {
        chef: file(relativePath: { eq: "depoimentos.jpg" }) {
          childImageSharp {
            fluid(quality: 90) {
              ...GatsbyImageSharpFluid
              ...GatsbyImageSharpFluidLimitPresentationSize
            }
          }
        }
      }
    `}
    render={(data) => (
      <S.TestimoniesWrapper {...rest}>
        <S.TestimoniesImage fluid={data.chef.childImageSharp.fluid} />
      </S.TestimoniesWrapper>
    )}
  />
)

export default Testimonies
